export default {"src":"/_next/static/media/contest-benefits-4.ec96d32a.svg","height":245,"width":555,"blurWidth":0,"blurHeight":0};